import { RiTeamFill, RiDeleteBinFill } from 'react-icons/ri';
import { FaRegEdit, FaKey } from 'react-icons/fa';
import { listaEstadosActivo } from "../../../app/constants/constants-selectores";
import { obtenerLabel } from "../../../shared/utils/funciones";
import { TablaSkeleton } from "../../../shared/ui/TablaSkeleton";

// Props presentacionales; la lógica vive en UsuariosPage. `watch` (react-hook-form)
// y los handlers se tipan laxo (`any`) por pragmatismo en la migración.
interface UsuariosTablaProps {
    isLoading: boolean;
    listaUsuarios: any[];
    listaSucursales: any[];
    buscar: boolean;
    watch: any;
    mostrarBotonUsuarioGrupo: boolean;
    mostrarBotonUsuarioResetearContraseña: boolean;
    mostrarBotonEditar: boolean;
    mostrarBotonEliminar: boolean;
    usuarioGrupo: (...args: any[]) => any;
    resetPassword: (...args: any[]) => any;
    usuarioEditar: (...args: any[]) => any;
    usuarioEliminar: (...args: any[]) => any;
}

// DT1 (refactor por tamaño): tabla de resultados de la página Usuarios.
// Toda la lógica permanece en UsuariosPage; aquí sólo el JSX presentacional.
export const UsuariosTabla = ({
    isLoading,
    listaUsuarios,
    listaSucursales,
    buscar,
    watch,
    mostrarBotonUsuarioGrupo,
    mostrarBotonUsuarioResetearContraseña,
    mostrarBotonEditar,
    mostrarBotonEliminar,
    usuarioGrupo,
    resetPassword,
    usuarioEditar,
    usuarioEliminar,
}: UsuariosTablaProps) => {
    return (
        <div className="tw-mt-2 tw-rounded-2xl tw-bg-white tw-p-3 tw-shadow-md tw-border tw-border-gray-100 tw-overflow-x-auto">
            <table className="table table-hover tw-mb-0">
                <thead className="table-light">
                    <tr>
                        <th scope="col" className="col text-center">Usuario</th>
                        <th scope="col" className="col text-center">Nombre Completo</th>
                        <th scope="col" className="col text-center">Sucursal</th>
                        <th scope="col" className="col text-center">Sede</th>
                        <th scope="col" className="col text-center">Estado</th>
                        {/* <th scope="col" className="col text-center">Clave</th> */}
                        {
                            mostrarBotonUsuarioGrupo && (
                                <th scope="col" className="col text-center">Grupo</th>
                            )

                        }
                        {
                            mostrarBotonUsuarioResetearContraseña && (
                                <th scope="col" className="col text-center">Reiniciar</th>
                            )
                        }

                        {
                            mostrarBotonEditar && (
                                <th scope="col" className="col text-center">Editar</th>
                            )
                        }
                        {
                            mostrarBotonEliminar && (
                                <th scope="col" className="col text-center">Eliminar</th>
                            )
                        }

                    </tr>
                </thead>
                <tbody className={isLoading ? "" : "tabla-fade-in"}>

                    {
                        // Skeleton solo en la carga inicial (sin datos). En refetch (p.ej. al
                        // cerrar un modal) se conservan las filas actuales y se reemplazan sin
                        // salto/parpadeo (evita el "desencaje").
                        (isLoading && !listaUsuarios?.length) ? (
                            <TablaSkeleton rows={6} cols={6} />

                        ) : (
                            listaUsuarios?.length > 0 ? listaUsuarios.map((u) => (
                                <tr key={u?.UseCod}>
                                    <td>{u?.UseCod}</td>
                                    <td>{u?.UseNomCom}</td>
                                    <td>{obtenerLabel(listaSucursales, u?.UseComp)}</td>
                                    {/* Multi Sede Usuarios: sede primaria + "+N" si tiene más sedes (TMUSE20) */}
                                    <td>
                                        {u?.TMSED10?.SedDesc}
                                        {u?.SedesTotal > 1 && (
                                            <span className="badge bg-secondary ms-1" title={`El usuario tiene ${u.SedesTotal} sedes asignadas`}>
                                                +{u.SedesTotal - 1}
                                            </span>
                                        )}
                                    </td>
                                    <td>{obtenerLabel(listaEstadosActivo, u?.UseEst)}</td>
                                    {/* <td><FcKey size={23} cursor={'pointer'} data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => usuarioPassword(u?.UseCod)} /></td> */}
                                    {
                                        // Compañía REAL del usuario (u.UseComp), no el filtro watch("sucursal"):
                                        // si el filtro quedó desincronizado (cambiado sin "Buscar"), MostrarUserGroup
                                        // no encontraba al usuario -> 401. Fallback al filtro por compatibilidad.
                                        mostrarBotonUsuarioGrupo && (
                                            <td><RiTeamFill size={23} cursor={'pointer'} className="color-iconos" onClick={() => usuarioGrupo(u?.UseComp || watch("sucursal"), u?.UseNomCom, u?.UseCod)} /></td>
                                        )
                                    }
                                    {
                                        mostrarBotonUsuarioResetearContraseña && (
                                            <td>
                                                <FaKey size={20} cursor={'pointer'} className="color-iconos" title="Reiniciar contraseña" onClick={()=> resetPassword(u?.UseCod)}/>
                                            </td>
                                        )
                                    }

                                    {/* <td><RiUserSettingsLine size={23} cursor={'pointer'} color="#27AE60" onClick={usuarioPermisos} /></td> */}
                                    {
                                        mostrarBotonEditar && (
                                            <td><FaRegEdit size={23} cursor={'pointer'} className="color-iconos" onClick={() => usuarioEditar(u?.UseCod)} /></td>
                                        )
                                    }
                                    {
                                        mostrarBotonEliminar && (
                                            <td><RiDeleteBinFill size={23} cursor={'pointer'} color="#C0392B" onClick={() => usuarioEliminar(u?.UseCod, u?.UseNomCom)} /></td>
                                        )
                                    }
                                </tr>
                            )) :
                                (
                                    (buscar) ? (
                                        <tr>
                                            <td colSpan={100} className="text-center">No hay usuarios</td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <td colSpan={100} className="text-center">Realice una búsqueda</td>
                                        </tr>
                                    )
                                )
                        )
                    }
                </tbody>
            </table>
        </div>
    )
}
